var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymenticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 13.998,
    viewBox: "0 0 19 13.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "PaymentOverview",
    x: 0,
    y: 0,
    width: 19,
    height: 13.998,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PaymentOverview-2",
    "data-name": "PaymentOverview",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#PaymentOverview)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PaymentOverview-3",
    "data-name": "PaymentOverview",
    d: "M23864.5,24512h-13a1.5,1.5,0,0,1-1.5-1.5v-5.273h16v5.273A1.5,1.5,0,0,1,23864.5,24512Zm1.5-8.463h0l-16,0,0-1.039a1.5,1.5,0,0,1,1.5-1.494h13a1.5,1.5,0,0,1,1.5,1.494v1.041Z",
    transform: "translate(-23848.5 -24500.5)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymenticon);
export default __webpack_public_path__ + "static/media/Payment icon.af74bddca78de477708399f2701ceef2.svg";
export { ForwardRef as ReactComponent };